import styled from 'styled-components';

const OuterBar = styled.div `
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.colors.background.tertiary};
`;
const InnerBar = styled.div `
  width: ${props => props.percentage}%;
  height: 8px;
  background-color: ${props => props.theme.colors.background.successBright};
  border-radius: 4px;
  transition: width ${props => props.secondsToProgress}s linear;
`;

export { InnerBar, OuterBar };
